<template>
    <div class="max-w-[751px] w-full h-full">
        <div>
            <div class="mt-14">
                <h1 class="text-primary font-bold">Desempenho Individual</h1>
                <p>
                    Veja suas últimas atividades. Use o filtro abaixo para ver
                    mais opções.
                </p>
            </div>
            <div class="flex items-center gap-x-4">
                <FilterIndividualPerformance
                    :campaigns="campaigns"
                    :seasonWeeks="weeks"
                    @updateFilter="filterIndividualPerformance($event)"
                />
                <a
                    v-if="isFiltered"
                    class="text-blue-600s hover:underline cursor-pointer text-sm"
                    @click="clearFilter()"
                    >Limpar Filtro</a
                >
            </div>
            <div class="flex flex-col gap-y-2">
                <RadialTeamPerformanceGoal :teamPerformance="teamPerformanceData" :individualPerformance="participantPerformanceWithWeightData"/>
                <p class="text-[10px] text-left flex items-center">Última atualização: {{ getCurrentDate() }}</p>
            </div>
            <div class="bg-white rounded-2xl border-primary border p-4 sm:p-2 mt-6">
                <div class="flex flex-col break-words">
                    <section>
                        <div
                            id="infinite-list"
                            class="max-h-[70vh] overflow-auto"
                        >
                            <div
                                class="text-black font-bold rounded xl:px-4 grid grid-cols-3 border border-transparent"
                            >
                                <p
                                    @click="setPropertyAmount"
                                    class="pb-6 text-primary border-r-2 border-[#BBB5B5] flex flex-wrap justify-center items-center gap-x-2"
                                >
                                    Quantidade de Fotos
                                    <Icon
                                        name="Seta"
                                        class="cursor-pointer"
                                        :class="
                                            propertyFilter == 'amountHigher'
                                                ? 'rotate-180'
                                                : ''
                                        "
                                    />
                                </p>
                                <p
                                    @click="setPropertyDate"
                                    class="pb-6 text-primary text-center border-r-2 border-[#BBB5B5] flex flex-wrap items-center justify-center gap-x-2"
                                >
                                    Data do Upload<Icon
                                        name="Seta"
                                        class="cursor-pointer"
                                        :class="
                                            propertyFilter == 'dateHigher'
                                                ? 'rotate-180'
                                                : ''
                                        "
                                    />
                                </p>
                                <p
                                @click="setPropertyStatus"
                                    class="pb-6 text-primary text-center flex flex-wrap items-center justify-center gap-x-2"
                                >
                                    Status<Icon
                                        name="Seta"
                                        class="cursor-pointer"
                                        :class="
                                            propertyFilter == 'statusHigher'
                                                ? 'rotate-180'
                                                : ''
                                        "
                                    />
                                </p>
                            </div>
                            <div
                                v-for="(
                                    item, key
                                ) in orderedParticipantPerformance"
                                :key="key"
                                class="rounded-xl xl:px-4 grid grid-cols-3 grid-cols-ranking-participants border border-[#DBDBDB]"
                            >
                                <div
                                    class="border-r-2 border-[#BBB5B5] flex flex-col justify-center items-center py-4"
                                >
                                    <p class="flex sm:justify-center">
                                        {{ item.pictures?.length }}
                                    </p>
                                    <a
                                        @click="showInModal(item.pictures)"
                                        class="text-blue-600 hover:underline cursor-pointer"
                                        >Exibir Fotos</a
                                    >
                                </div>
                                <p
                                    class="border-r-2 border-[#BBB5B5] flex items-center justify-center"
                                >
                                    {{ formatDate(item.createdAt) }}
                                </p>
                                <div
                                    class="flex flex-col justify-center items-center py-4 sm:px-2"
                                >
                                    <p
                                        v-if="item.validation?.status === 'A'"
                                        class="py-4 px-3 border rounded-2xl text-center bg-green-200 border-success"
                                    >
                                        Enviada
                                    </p>
                                    <p
                                        v-if="item.validation?.status === 'R'"
                                        class="py-4 px-3 border rounded-2xl text-center bg-red-200 border-error"
                                    >
                                        Reprovada
                                    </p>
                                    <p
                                        v-if="
                                            ['A', 'R'].indexOf(
                                                item.validation?.status
                                            ) < 0
                                        "
                                        class="py-4 px-3 border rounded-2xl text-center bg-green-200 border-success"
                                    >
                                        Enviada
                                    </p>
                                    <div
                                        @click="
                                            currentReason =
                                                item.validation.denyReason
                                        "
                                        class="text-blue-600 hover:underline cursor-pointer mt-2"
                                        v-bind:class="{
                                            hidden:
                                                item.validation?.status !== 'R',
                                        }"
                                    >
                                        Saiba o motivo
                                    </div>
                                </div>
                            </div>
                            <label
                                v-if="loading"
                                class="flex justify-center w-100"
                            >
                                Carregando...
                            </label>
                        </div>
                    </section>
                </div>
                <!-- <p class="text-[10px]">Última atualização: 22/03/2021 às 15h43</p> -->
            </div>
        </div>
    </div>
    <Gallery :gallery="currentGallery" />
    <transition v-if="currentReason">
        <div
            class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
        >
            <div
                class="relative bg-white border-[1px] border-gray-200 rounded-[4px] max-w-[348px] w-full px-4 py-4 flex flex-col"
            >
                <button
                    class="absolute top-2 right-2"
                    @click="currentReason = ''"
                >
                    <Icon name="Fechar" />
                </button>
                <h1 class="text-[20px] font-bold text-primary">
                    Possível motivo
                </h1>
                <p class="mt-2.5 break-words">{{ currentReason }}</p>
                <button
                    class="transition-all self-center max-w-[94px] mt-2 p-4 bg-white border border-primary rounded-2xl font-bold text-primary hover:bg-gray-300 hover:border-gray-300"
                    @click="currentReason = ''"
                >
                    Entendi
                </button>
            </div>
        </div>
    </transition>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";
import FilterIndividualPerformance from "@/Components/FilterIndividualPerformance.vue";
import Gallery from "@/Components/Gallery.vue";
import RadialTeamPerformanceGoal from '@/Components/Performance/Individual/RadialTeamPerformanceGoal.vue';
import moment from 'moment';

export default {
    components: {
        Icon,
        FilterIndividualPerformance,
        Gallery,
        RadialTeamPerformanceGoal
    },
    props: {
        campaigns: Object,
        regions: Object,
        subregions: Object,
        jobTitle: Object,
        participantPerformance: Array,
        teamPerformance: Object,
        participantPerformanceWithWeight: Object,
    },
    data() {
        return {
            loadedGalleries: this.participantPerformance?.galleries || [],
            totalGalleries: this.participantPerformance?.total || 0,
            propertyFilter: "",
            currentGallery: "",
            currentReason: "",
            weeks: [],
            loading: false,
            currentPage: 0,
            limit: 10,
            orderBy: undefined,
            orderDirection: undefined,
            teamPerformanceData: this.teamPerformance,
            participantPerformanceWithWeightData: this.participantPerformanceWithWeight,
        };
    },
    computed: {
        orderedParticipantPerformance: function () {
            return this.orderParticipantPerformance(
                this.loadedGalleries,
                this.propertyFilter
            );
        },
    },
    mounted() {
        this.fetchWeeks();

        this.initInfiniteScroll();
    },
    methods: {
        getCurrentDate() {
            return new moment().format('DD/MM/YYYY [às] HH:mm');
        },
        initInfiniteScroll() {
            const listElm = document.querySelector("#infinite-list");
            listElm.addEventListener("scroll", (e) => {
                if (
                    listElm.scrollTop + listElm.clientHeight >=
                    listElm.scrollHeight - 100
                ) {
                    if (
                        !this.loading &&
                        this.loadedGalleries?.length < this.totalGalleries
                    )
                        this.loadNextPage();
                }
            });
        },
        fetchWeeks() {
            const actualWeek = moment().startOf("isoWeek").format("W");
            const MomentWeek = moment()
                .week(actualWeek)
                .startOf("isoWeek")
                .format("W");
            const hotfix = actualWeek != MomentWeek ? 1 : 0;

            let weeksInYear = moment().isoWeeks();

            for (
                let weekNumber = 1;
                weekNumber < weeksInYear + 1;
                weekNumber++
            ) {
                const startDay = moment()
                    .week(weekNumber + hotfix)
                    .startOf("week");
                const endDay = moment()
                    .week(weekNumber + hotfix)
                    .endOf("week");

                const week = {
                    name: `Semana ${weekNumber}`,
                    start: startDay.locale("pt-br").format("DD/MM/YYYY"),
                    startFormatted: startDay
                        .locale("pt-br")
                        .format("YYYY-MM-DD"),
                    end: endDay.locale("pt-br").format("DD/MM/YYYY"),
                    endFormatted: endDay.locale("pt-br").format("YYYY-MM-DD"),
                };

                this.weeks.push(week);
            }
        },
        filterIndividualPerformance(data) {
            this.loadedGalleries = [];
            this.total = 0;
            this.filterData = data;
            this.currentPage = 0;

            this.fetchGalleries(data);
        },
        showInModal(photos) {
            this.currentGallery = {
                exhibition: photos[0],
                photos: photos,
            };
        },
        formatDate(date) {
            let d = new Date(date);

            let options = {
                day: "numeric",
                month: "2-digit",
            };

            return d.toLocaleString("pt-br", options);
        },
        orderParticipantPerformance(array, property) {
            let arrayC = Object.create(array);
            if (property == "amountHigher") {
                return arrayC.sort(function (a, b) {
                    if (a.pictures?.length < b.pictures?.length) {
                        return 1;
                    }
                    if (a.pictures?.length > b.pictures?.length) {
                        return -1;
                    }
                    return 0;
                });
            }
            if (property == "amountLower") {
                return arrayC.sort(function (a, b) {
                    if (a.pictures?.length < b.pictures?.length) {
                        return -1;
                    }
                    if (a.pictures?.length > b.pictures?.length) {
                        return 1;
                    }
                    return 0;
                });
            }
            if (property == "dateHigher") {
                return arrayC.sort(function (a, b) {
                    if (a.createdAt < b.createdAt) {
                        return 1;
                    }
                    if (a.createdAt > b.createdAt) {
                        return -1;
                    }
                    return 0;
                });
            }
            if (property == "dateLower") {
                return arrayC.sort(function (a, b) {
                    if (a.createdAt < b.createdAt) {
                        return -1;
                    }
                    if (a.createdAt > b.createdAt) {
                        return 1;
                    }
                    return 0;
                });
            }

            let weight = ["R", "N", "A"];

            if (property == "statusHigher") {
                return arrayC.sort(function (a, b) {
                    let x = a.validation
                        ? weight.indexOf(a.validation.status)
                        : -2;
                    let y = b.validation
                        ? weight.indexOf(b.validation.status)
                        : -2;

                    if (x < y) {
                        return 1;
                    }
                    if (x > y) {
                        return -1;
                    }
                    return 0;
                });
            }
            if (property == "statusLower") {
                return arrayC.sort(function (a, b) {
                    let x = a.validation
                        ? weight.indexOf(a.validation.status)
                        : -2;
                    let y = b.validation
                        ? weight.indexOf(b.validation.status)
                        : -2;

                    if (x < y) {
                        return -1;
                    }
                    if (x > y) {
                        return 1;
                    }
                    return 0;
                });
            }
            return arrayC;
        },
        setPropertyAmount() {
            this.propertyFilter == "amountHigher"
                ? (this.propertyFilter = "amountLower")
                : (this.propertyFilter = "amountHigher");
        },
        setPropertyDate() {
            if (this.loadedGalleries?.length < this.totalGalleries) {
                this.filterIndividualPerformance({
                    ...this.filterData,
                    orderBy: "createdAt",
                    orderDirection:
                        this.propertyFilter == "dateHigher" ? "ASC" : "DESC",
                });
            }
            this.propertyFilter == "dateHigher"
                ? (this.propertyFilter = "dateLower")
                : (this.propertyFilter = "dateHigher");
        },
        setPropertyStatus() {
            if (this.loadedGalleries?.length < this.totalGalleries) {
                this.filterIndividualPerformance({
                    ...this.filterData,
                    orderBy: "status",
                    orderDirection:
                        this.propertyFilter == "statusHigher" ? "ASC" : "DESC",
                });
            }
            this.propertyFilter == "statusHigher"
                ? (this.propertyFilter = "statusLower")
                : (this.propertyFilter = "statusHigher");
        },
        fetchGalleries(data) {
            this.loading = true;

            axios
                .get("/performance/individual/data", { params: data })
                .then((response) => {
                    this.teamPerformanceData = response?.data?.teamPerformance;
                    this.participantPerformanceWithWeightData = response?.data?.participantPerformanceWithWeight;

                    if (Array.isArray(response?.data?.galleries))
                        this.loadedGalleries = this.loadedGalleries.concat(
                            response?.data?.galleries || []
                        );
                    this.totalGalleries = response?.data?.total;

                    this.loading = false;
                });
        },
        loadNextPage() {
            this.currentPage += 1;
            this.fetchGalleries({
                ...this.filterData,
                limit: this.limit,
                page: this.currentPage,
            });
        },
    },
};
</script>
<style scoped>
.grid-cols-ranking-participants:nth-child(2n + 2) {
    background-color: #dbdbdb;
}
</style>
